import React from "react";
// import { FaCircleCheck } from "react-icons/fa6";
// import { IoCloseCircleSharp } from "react-icons/io5";
// import { FaWindowClose } from "react-icons/fa";
import { FaCheckSquare } from "react-icons/fa";
import { BiSolidXSquare } from "react-icons/bi";

function PreviousResultCard({ result }) {
  return (
    <div className="previous_result_card">
      <h5>{result.day}</h5>
      <h4>{result.month}</h4>
      <h4>{result.odds}</h4>

      {result.result === "won" ? (
        <FaCheckSquare className="icon_won" />
      ) : (
        <BiSolidXSquare className="icon_lost" />
      )}
    </div>
  );
}

export default PreviousResultCard;
